/* unplugin-vue-components disabled */import script from "./NewestArticle.vue?vue&type=script&lang=ts&setup=true"
export * from "./NewestArticle.vue?vue&type=script&lang=ts&setup=true"

import "./NewestArticle.vue?vue&type=style&index=0&id=496366f5&scoped=true&lang=less"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-496366f5"]])

export default __exports__